import styled from "@emotion/styled";

import { DesignToken, RadiusToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import { withVar } from "themes/helpers";

import { VARIABLE_ICON_CUSTOM_COLOR } from "../constants";

export const StyledFlex = styled(Flex)`
  align-items: center;

  label {
    margin-right: 8px;
  }

  .lc-text-field {
    position: relative;
    top: 10px;
  }

  .lc-field-error {
    height: 0px;
    overflow: visible;
    margin-top: 0px;
    position: relative;
    top: 2px;
  }

  .lc-input,
  .lc-select {
    margin-right: 8px;
  }

  .lc-select {
    min-width: 200px;
  }

  .lc-select-head {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    .lc-input,
    .lc-select {
      margin-bottom: 8px;
    }
  }
`;

export const StyledBar = styled.div`
  border-bottom: 1px ${withVar(DesignToken.BorderBasicSecondary)} solid;
  padding: 8px 12px;
  background-color: ${withVar(DesignToken.SurfaceSecondaryDefault)};
  .template-status {
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }

  .bar-icon {
    margin: 0 5px;
  }

  .menu-item {
    display: flex;
    align-items: center;

    & .add-variable-icon {
      & path {
        fill: ${VARIABLE_ICON_CUSTOM_COLOR};
      }
      padding-top: 5px;
      padding-right: 5px;
      line-height: unset;
    }

    & .add-variable {
      padding-right: 40px;
    }
  }
`;

export const EditorWrapper = styled.div<{ isBannerVisible: boolean }>`
  border: 1px ${withVar(DesignToken.BorderBasicSecondary)} solid;
  border-radius: 4px;
  .CodeMirror {
    height: calc(100vh - ${(p): string => (p.isBannerVisible ? "237px" : "185px")});
  }

  .CodeMirror-gutter.CodeMirror-linenumbers,
  .CodeMirror-linenumber {
    background-color: ${withVar(DesignToken.SurfaceSecondaryDefault)};
  }
  .CodeMirror-lines {
    padding-bottom: 120px;
  }
  .editor-disabled {
    opacity: 0.6;
  }
`;

type IIframeBox = {
  width: string;
  isBannerVisible?: boolean;
  isVisualBuilderPreview?: boolean;
  isSaveBarVisible: boolean;
};

function previewHeight(
  isVisualBuilderPreview: boolean | undefined,
  isBannerVisible: boolean | undefined,
  isSaveBarVisible: boolean
): string {
  if (isVisualBuilderPreview && isBannerVisible) {
    return `calc(100vh - 168px${isSaveBarVisible ? " - 100px" : ""})`;
  }
  if (isVisualBuilderPreview && !isBannerVisible) {
    return `calc(100vh - 117px${isSaveBarVisible ? " - 100px" : ""})`;
  }
  if (!isVisualBuilderPreview && isBannerVisible) {
    return `calc(100vh - 257px${isSaveBarVisible ? " - 100px" : ""})`;
  }
  return `calc(100vh - 205px${isSaveBarVisible ? " - 100px" : ""})`;
}

export const IframeBox = styled.div<IIframeBox>`
  border: 1px ${withVar(DesignToken.BorderBasicSecondary)} solid;
  border-radius: ${withVar(RadiusToken.Radius3)};

  iframe {
    width: ${(p): string => p.width};
    height: ${(p): string => previewHeight(p.isVisualBuilderPreview, p.isBannerVisible, p.isSaveBarVisible)};
    overflow: auto;
    margin: 0 auto;
  }
`;

export const PreviewHeader = styled.div<{ isVisualBuilderPreview?: boolean }>`
  padding: 0 8px 8px 8px;
`;
